// LogIn.tsx - Minimal version
import React from "react";
import "./login.scss";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import FormPasswordField from "../../components/formFields/FormPasswordField";
import {
  passwordValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import { useNavigate } from "react-router-dom";
import { employeeLogin } from "./loginSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import Logo from "../../assets/Images/Logo.png";

const LogIn: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => state.login.loading);

  const handleSubmit = async (values: any) => {
    const data = {
      UserName: values.UserName,
      Password: values.Password,
    };
    const response = await dispatch(employeeLogin(data));
    if (response?.meta?.requestStatus === "fulfilled") {
      navigate("/");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src={Logo} alt="Logo" className="login-logo" />
        <h2>Welcome Back</h2>
        <p>Please login to your account</p>

        <Form
          onSubmit={handleSubmit}
          initialValues={{ UserName: "", Password: "" }}
          render={({ allowSubmit }) => (
            <FormElement>
              <Field
                name="UserName"
                type="text"
                component={FormTextField}
                label="Username"
                placeholder="Enter your username"
                validator={requiredValidator}
                astrike={true}
              />

              <Field
                name="Password"
                type="password"
                component={FormPasswordField}
                label="Password"
                placeholder="Enter your password"
                validator={passwordValidator}
                astrike={true}
              />

              <ButtonWithLoading
                label="Sign In"
                themeColor="primary"
                type="submit"
                width="100%"
                disabled={!allowSubmit || loading}
                loading={loading}
              />
            </FormElement>
          )}
        />
      </div>
    </div>
  );
};

export default LogIn;
